import { ChatOutlinedIcon, TodayIcon } from "icons";
import theme from "theme";
import { colors } from "theme/palette";

import Stack from "components/Stack";
import Text from "components/Text";
import Tooltip from "components/Tooltip";

import LightningIcon from "entities/Field/components/FieldUpdateIcon/assets/lightningIcon.svg";

export interface INotifications {
  updatedFieldCount: number;
  taskCount: number | React.ReactNode;
  unreadMessageCount: number | React.ReactNode;
}

const Notifications = ({
  updatedFieldCount,
  taskCount,
  unreadMessageCount,
}: INotifications) => (
  <Stack spacing={1} data-testid="updates-and-notifications-section">
    <Text variant="labelSmall" color={colors.gray40} fontWeight={500}>
      updates & notifications
    </Text>

    <Stack direction="row" gap={0.5} flexWrap="wrap">
      <Tooltip title="Updated items">
        <Stack
          padding={theme.spacing(0.5, 1)}
          direction="row"
          alignItems="center"
          gap={0.75}
          sx={{
            borderRadius: "16px",
            backgroundColor: colors.gray5,
            border: `1px solid ${colors.gray60}`,
          }}
          data-testid="updated-items"
        >
          <Stack
            sx={{
              backgroundColor: colors.blue100,
            }}
            borderRadius="10px"
            alignItems="center"
            justifyContent="center"
            height="16px"
            width="16px"
          >
            <img
              src={LightningIcon}
              alt=""
              width="6px"
              height="8px"
              data-testid="field-updated-icon"
            />
          </Stack>

          <Text
            variant="text4"
            fontWeight={500}
            color={colors.gray100}
            data-testid="updated-items-count"
          >
            {updatedFieldCount}
          </Text>
        </Stack>
      </Tooltip>

      <Tooltip title="Open tasks">
        <Stack
          padding={theme.spacing(0.5, 1)}
          direction="row"
          alignItems="center"
          gap={0.75}
          sx={{
            borderRadius: "16px",
            backgroundColor: colors.gray5,
            border: `1px solid ${colors.gray60}`,
          }}
          data-testid="open-tasks"
        >
          <TodayIcon
            sx={{ height: "16px", width: "16px", color: colors.gray100 }}
          />

          <Text
            variant="text4"
            fontWeight={500}
            color={colors.gray100}
            data-testid="open-tasks-count"
          >
            {taskCount}
          </Text>
        </Stack>
      </Tooltip>

      <Tooltip title="Unread messages">
        <Stack
          padding={theme.spacing(0.5, 1)}
          direction="row"
          alignItems="center"
          gap={0.75}
          sx={{
            borderRadius: "16px",
            backgroundColor: colors.gray5,
            border: `1px solid ${colors.gray60}`,
          }}
          data-testid="unread-messages"
        >
          <ChatOutlinedIcon
            sx={{ height: "16px", width: "16px", color: colors.gray100 }}
          />

          <Text
            variant="text4"
            fontWeight={500}
            color={colors.gray100}
            data-testid="unread-messages-count"
          >
            {unreadMessageCount}
          </Text>
        </Stack>
      </Tooltip>
    </Stack>
  </Stack>
);

export default Notifications;
